/* eslint-disable jsdoc/check-param-names */
import React, { useState } from 'react';
import { TextField } from '@mui/material';

/**
 * @param {string} value
 * @param {object} params
 * @param {string} placeholder
 * @param {string} exampleFormat
 * @returns {React.ReactElement}
 * @class
 */
export const SearchTextfield = ({ value, params, placeholder = 'Search By ID Or Name', exampleFormat }) => {
    const [placeholderText, setPlaceholderText] = useState(placeholder);

    return (
        <TextField
            {...params}
            value={value}
            variant="standard"
            placeholder={placeholderText}
            onFocus={() => {
                setPlaceholderText(`e.g. ${exampleFormat}`);
            }}
            onBlur={() => {
                setPlaceholderText(placeholder);
            }}
        />
    );
};
